// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2JtYq","validationTips":"StatementDescriptor_validationTips__3U6vs"};